export interface IWebsiteCloneForm {
  /** holds the selected env websiteId */
  env: number;
  subdomain: string;
  region: string;
}

export interface IWebsiteCloneData {
  websiteId: number;
  subdomain: string;
  region: string;
}

export class WebsiteCloneData implements IWebsiteCloneData {

  websiteId: number;
  subdomain: string;
  region: string;

  constructor(websiteData: IWebsiteCloneForm) {
    this.websiteId = websiteData.env;
    this.region = websiteData.region;
    this.subdomain = websiteData.subdomain;
  }
}
